$(document).ready(function() { 
  // Accordion section
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    var links = this.el.find('.accordion-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }
  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
    $next = $this.next();
    $next.slideToggle();
    $this.parent().toggleClass('open');
    if (!e.data.multiple) {
      $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.accordion-container'), false);  
  
  //	Featured Product Carousel
  $('.featured-product').owlCarousel({
    loop: true,
    margin: 50,
    responsiveClass: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      481: {
        margin: 10,
        items: 3
      },
      769: {
        items: 3
      },
      992: {
        items: 4
      }
    }
  }); 
  
  //	Featured Product Carousel
  $('.featured-product-carousel').owlCarousel({
    loop: true,
    margin: 50,
    responsiveClass: true,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      481: {
        margin: 10,
        items: 3
      },
      769: {
        items: 3
      },
      992: {
        items: 4
      }
    }
  });
  
});   


$(document).ready(function() { 
  $('.cart-button').click(function(event){
    event.preventDefault();
    ajaxCart.load();
    $('.drop-cart').addClass('open');
    $('body').addClass('open-cart');
  });
  
  $(document).bind('mouseup touchend', function(e){
    var container = $('.drop-cart');
    if ($('.drop-cart').hasClass('open')) {
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.drop-cart').removeClass('open');
        $('body').removeClass('open-cart');
      }
    }
  });
  
  
  $('.open-quick-view').magnificPopup({
    type:'inline',
    midClick: true,
    mainClass: 'quickView'
  }); 
  
  //Nutrition ingredients popup product page
  $('.open-nutrition-ingredients').magnificPopup({
    type: 'inline',
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: 'nutrition-ingredients mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 300 // don't foget to change the duration also in CSS
    }
  });
  
  $('.mobile-nav-trigger').click(function(){
    $('.pop-mobile-nav').addClass('open');
    $('body').addClass('noscroll');
  });
  
  $('.nav-close').click(function(){
    $('.pop-mobile-nav').removeClass('open');
    $('body').removeClass('noscroll');
  });
  
  
  $(window).bind('scroll', function() {
    //var navHeight = $( window ).height() - 60;
    if ($(window).scrollTop() > 200) {
      $('.logo__image-wrapper').addClass('fixed-menu');
    }else {
      $('.logo__image-wrapper').removeClass('fixed-menu');
    }
  });
  
  
});
  
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
  
 
  
  
  
  
  
  
  
  
  
  
  
  
  